export default __webpack_public_path__ + "static/media/two.fb11e3e1.jpeg";